export const getlocalStorage = () => {
    const is_free = localStorage.getItem("is_free");
    const is_subscription = localStorage.getItem("is_subscription");
    const is_role = localStorage.getItem("is_role");
    const service = localStorage.getItem("service");
    const subscription_id =localStorage.getItem("subscription_id");
    const product_id =localStorage.getItem("product_id");
    return { is_free, is_subscription, is_role, service, subscription_id,product_id}
};
  